import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  FAQ,
  IconSuccess,
  IconTrailerShield,
} from '../../components';

import css from './RoadsidePage.module.css';

import nrmaLogo from './assets/nrma-logo.png';

const RoadsidePage = () => {
  return (
    <StaticPage
      title="Roadside Assistance"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'RoadsidePage',
        description: 'Roadside assistance information on localtrailerhire.com.au',
        name: 'Roadside assistance page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <ul className={css.sections}>
            <li className={css.section}>
              <div className={`${css.sectionContent} ${css.columns}`}>
                <h1 className={css.sectionTitle}>
                  Help is just a call away. Drive with confidence.
                </h1>
                <div>
                  <p>
                    Roadside Assistance provided by the NRMA is included with your hire when you
                    book a listing that offers it. If you run into trouble — like a mechanical issue
                    with the trailer, a flat tyre, or a wheel problem, or the trailer needs towing —
                    help will be on the way.
                  </p>
                </div>
                <div className={css.highlightBox}>
                  <img src={nrmaLogo} alt="NRMA Logo" className={css.nrmaLogo} />
                  <h3 className={css.sectionSubtitle}>
                    Roadside Assistance provided by the NRMA includes:
                  </h3>
                  <div className={css.glanceSection}>
                    <div className={css.glanceRow}>
                      <IconSuccess fillColor={'var(--marketplaceColor)'} />
                      <span>
                        <b>Mechanical trouble?</b> We’ll help get it sorted.
                      </span>
                    </div>
                    <div className={css.glanceRow}>
                      <IconSuccess fillColor={'var(--marketplaceColor)'} />
                      <span>
                        <b>Flat tyre or wheel issues?</b> We'll assist.
                      </span>
                    </div>
                    <div className={css.glanceRow}>
                      <IconSuccess fillColor={'var(--marketplaceColor)'} />
                      <span>
                        <b>Trailer can’t continue?</b> Towing support is available.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className={css.section}>
              <div className={css.sectionContent}>
                <h1 className={css.sectionTitle}>Important Note</h1>
                <div className={css.importantNote}>
                  <p>
                    Not all trailers include Roadside Assistance. Look for the{' '}
                    <IconTrailerShield size={30} /> <b>Roadside & Trailer Shield</b> tag when
                    searching for trailers.
                  </p>
                </div>
              </div>
            </li>

            <li className={css.section}>
              <div className={css.sectionContent}>
                <h1 className={css.sectionTitle}>FAQs</h1>
                <div className={css.faqSection}>
                  <FAQ category={'roadside'} />
                </div>
              </div>
            </li>
          </ul>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default RoadsidePage;
